// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__u_mXb","title":"Faq_title__WHj_2","content":"Faq_content__8C2Yi"};